import { VOHomeElement, VOMedia } from "../model/DataStructure.js";
import { Resource } from "../model/Resource.js";
import { Home } from "./Home.js";
import { EditingImageItem } from "./items/EditingImageItem.js";

export class Editor {
    public element: HTMLDivElement;

    private _listItems: EditorListItem[] = [];
    private _header: HTMLDivElement;
    private _view: HTMLDivElement;
    private _control: HTMLDivElement;
    private _list: HTMLDivElement;
    private _current: EditorListItem = null;
    private _image: HTMLDivElement;
    private _drop: HTMLDivElement;
    private _sliderContainer: HTMLDivElement;
    private _uploading: boolean = false;
    private _slider: Slider;

    constructor(private _home: Home) {
        this.element = document.createElement("div");
        this.element.id = "editor";
        this.element.innerHTML = `
        <div class="editor-header"></div>
        <div class="editor-view">
            <div class="editor-view-image-container">
                <div class="editor-view-image"></div>
            </div>
        </div>
        <div class="editor-control disabled">
            <span class="control blue-button icon-471" title="Duplicate"></span>
            <span class="control blue-button remove icon-514" title="Remove"></span>
        </div>
        <div class="slider-container"></div>
        <div class="editor-list scrollbar vert"></div>
        <div class="editor-footer">
            <div class="editor-update blue-button">Update</div>
        </div>
        <div class="editor-drop hidden"></div>
        `;

        this._header = this.element.querySelector(".editor-header");
        this._view = this.element.querySelector(".editor-view");
        this._control = this.element.querySelector(".editor-control");
        this._list = this.element.querySelector(".editor-list");
        this._image = this.element.querySelector(".editor-view-image");
        this._drop = this.element.querySelector(".editor-drop");
        this._sliderContainer = this.element.querySelector(".slider-container");

        this._slider = new Slider();
        this._sliderContainer.appendChild(this._slider.element);

        var can = document.createElement("canvas");
        can.width = 3;
        can.height = 3;
        var ctx = can.getContext("2d");
        ctx.fillStyle = "rgba(0, 0, 0, 0.2)"
        ctx.fillRect(0, 2, 1, 1);
        ctx.fillRect(1, 1, 1, 1);
        ctx.fillRect(2, 0, 1, 1);
        this._header.style.backgroundImage = `url(${can.toDataURL()})`;

        var can = document.createElement("canvas");
        can.width = 20;
        can.height = 20;
        var ctx = can.getContext("2d");
        ctx.fillStyle = "rgba(0, 0, 0, 0.05)"
        ctx.fillRect(0, 0, 10, 10);
        ctx.fillRect(10, 10, 10, 10);
        this.element.querySelector<HTMLDivElement>(".editor-view-image-container").style.backgroundImage = `url(${can.toDataURL()})`;

        var drag = new e5.Drag(this._header, {
            stopPropagation: true
        });
        drag.target = this.element;
        drag.clamp = {
            tweenTime: 0.5,
            boundsParent: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            parent: document.getElementById("app")
        }

        this._image.addEventListener("click", () => {
            if (!this._current)
                return;
            this._home.tweenToHomeCategory(this._current.homeElement.category);
        });

        var counter = 0;
        this.element.addEventListener("dragenter", (e) => {
            if (this._uploading)
                return;
            e.preventDefault();
            counter++;
            this._drop.classList.remove("hidden");
        });

        this.element.addEventListener("dragover", (e) => {
            if (this._uploading)
                return;
            e.preventDefault();
        });

        this.element.addEventListener("dragleave", (e) => {
            if (this._uploading)
                return;
            counter--;
            if (counter <= 0)
                this._drop.classList.add("hidden");
        });

        this.element.addEventListener("drop", (ev) => {
            if (this._uploading)
                return;
            ev.preventDefault();
            // this._drop.classList.add("hidden");
            counter = 0;

            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.dataTransfer.items[i].kind === 'file') {
                        var file = ev.dataTransfer.items[i].getAsFile();
                        this.uploadFile(file);
                        break;
                    }
                }
            } else {
                // Use DataTransfer interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                    this.uploadFile(ev.dataTransfer.files[i]);
                    break;
                }
            }
        });

        this.element.querySelector(".editor-update").addEventListener("click", () => this.save());

        this.element.querySelector(".control.remove").addEventListener("click", () => {
            this._home.removeElement(this.current.item);
        });

        this._slider.onChange.add((z) => {
            if (!this.current)
                return;

            var homeElement = this.current.homeElement;
            homeElement.x = this.transformBack(homeElement);
            homeElement.z = z;

            var t = homeElement.x;
            // console.log("Z", z);

            var tx = homeElement.category.targetX;
            var x = homeElement.x;
            var z = homeElement.z;
            homeElement.x = (tx + x) - (tx / z);

            // console.log("X", t, " -> ", homeElement.x, " -> ", this.transformBack(homeElement));
            this._home.update();
        });
    }

    private save(): void {
        var elements: any[] = [];
        for (var element of this._home.home.elements) {
            elements.push({
                x: this.transformBack(element),
                y: element.y,
                z: element.z,
                image: element.image.id,
                animation: element.animation ? element.animation : "none"
            });
        }

        $.ajax({
            type: 'post',
            url: Resource.SAVE_ELEMENTS,
            data: {
                data: {
                    home_id: this._home.home.id,
                    elements: elements
                }
            },
            error: (xhr, status, error) => { console.log(xhr.responseText); },
            success: (response) => {
                if (!response) {
                    return;
                }

                if (response.result && response.result === "error") {
                    e5.Toast.showText(response.message);
                }
                console.log(response);
            },
            dataType: 'json'
        });
    }

    private transformBack(element: VOHomeElement): number {
        var homeCategory = element.category;
        var tx = homeCategory.targetX;
        var x = element.x;
        var z = element.z;
        return Math.round(x - (tx - (tx / z)));
    }

    private uploadFile(file: File): void {
        this._uploading = true;
        const reader = new FileReader();
        reader.onload = () => {
            var str = reader.result as string;
            var base64 = str.substr(str.indexOf("base64,") + 7);
            $.ajax({
                xhr: () => {
                    var xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            //Do something with upload progress here
                            console.log("UPLOAD", percentComplete);
                        }
                    }, false);

                    xhr.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            //Do something with download progress
                            console.log("UPLOAD", percentComplete);
                        }
                    }, false);

                    return xhr;
                },
                type: 'POST',
                url: Resource.UPLOAD_ATTACHMENT,
                data: {
                    attachment: base64
                },
                success: (response) => {
                    if (response && response.data) {
                        var media: VOMedia = response.data;
                        var x = -this._home.x + 1920 * 0.5;

                        var e: VOHomeElement = {
                            image: media,
                            index: this._home.home.elements.length,
                            x: x,
                            y: (1080 - media.height) * 0.5,
                            z: 1,
                            category: null
                        }
                        this._home.home.elements.push(e);
                        this._home.addElement(e);
                        this._home.update();
                        this.select(e);
                    } else {
                        console.log(response);
                        e5.Toast.showText("Could not upload media. " + (response ? response.message : ""), 8);
                    }
                    this._drop.classList.add("hidden");
                    this._uploading = false;
                }
            });
        };
        reader.readAsBinaryString
        reader.readAsDataURL(file);
    }

    public select(homeElement: VOHomeElement): void {
        var item = e5.array.match(this._listItems, "homeElement", homeElement);
        this.current = this.current === item ? null : item;

        if (this.current) {
            this._list.scrollTop = this.current.element.offsetTop - 10;
            // this.current.element.scrollIntoView();
        }
    }

    private handleClickItem(item: EditorListItem): void {
        // this._home.tweenToCategory(item.homeElement.category);
        // this.current = item;
        this.select(item.homeElement);
    }

    public get current(): EditorListItem {
        return this._current;
    }
    public set current(value: EditorListItem) {
        if (this._current === value)
            return;
        if (this._current) {
            this._current.active = false;
            this._current.item.selected = false;
        }
        this._current = value;
        if (this._current) {
            this._current.active = true;
            this._current.item.selected = true;
            this._image.style.backgroundImage = `url(${this._current.homeElement.image.url})`;
            // this._control.classList.remove("hidden");
            this._control.classList.remove("disabled");
            this._slider.value = this._current.homeElement.z;
            this._slider.disabled = false;
        } else {
            this._image.style.backgroundImage = null;
            // this._control.classList.add("hidden");
            this._control.classList.add("disabled");
            this._slider.value = 1;
            this._slider.disabled = true;
        }
    }

    public addItem(item: EditingImageItem): void {
        var listItem = new EditorListItem(item);
        listItem.onClick.add((item) => this.handleClickItem(item));
        this._listItems.push(listItem);
        this._list.appendChild(listItem.element);
    }

    public removeItem(item: EditingImageItem): void {
        var listItem = e5.array.match(this._listItems, "item", item);
        if (!listItem) {
            console.warn("Could not find editor list item for EditingImageItem:", item);
            return;
        }
        listItem.element.remove();
        if (this.current === listItem)
            this.current = null;
        this._listItems.splice(this._listItems.indexOf(listItem), 1);
        item.remove();
    }
}

class EditorListItem {
    public onClick = e5.Signal.create<[EditorListItem]>();
    public element: HTMLDivElement;
    public homeElement: VOHomeElement;

    constructor(public item: EditingImageItem) {
        this.element = document.createElement("div");
        this.element.className = "editor-list-item";
        this.element.style.backgroundImage = `url(${item.image.image.sizes.thumbnail})`;

        this.homeElement = item.image as VOHomeElement;

        this.element.addEventListener("click", () => this.onClick.dispatch(this));
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(active: boolean) {
        this.element.classList.toggle("active", active);
    }
}

class Slider {
    public onChange = e5.Signal.create<[number]>();

    public element: HTMLDivElement;

    private _thumb: HTMLDivElement;
    private _track: HTMLDivElement;
    private _drag: e5.Drag;
    private _input: HTMLInputElement;
    private _minValue: number = 0.1;
    private _maxValue: number = 2;

    constructor() {
        this.element = document.createElement("div");
        this.element.className = "slider disabled";

        this.element.innerHTML = `
        <input></input>
        <div class="track">
            <div class="line"></div>
            <div class="thumb"></div>
        </div>`;

        this._track = this.element.querySelector(".track");
        this._thumb = this.element.querySelector(".thumb");
        this._input = this.element.querySelector("input");
        this._input.value = (1).toFixed(2);

        this._drag = new e5.Drag(this._thumb, {
            stopPropagation: true,
            clamp: {
                parent: this.element.querySelector(".track") as HTMLElement,
                clampY: false
            },
            dragY: false,
            clampTrigger: e5.Trigger.ALL
        });

        this._drag.onDrag.add(() => {
            var pos = this._drag.position;
            var ratio = (pos.x) / (this._track.offsetWidth - (this._thumb.offsetWidth));
            var value = (this._maxValue - this._minValue) * ratio + this._minValue;
            this._input.value = value.toFixed(2);
        });

        this._drag.onClear.add(() => {
            this.onChange.dispatch(this.value);
        });

        this._input.addEventListener("change", () => {
            var stringValue = this._input.value.replace(",", ".");
            this.value = parseFloat(stringValue);
            this.onChange.dispatch(this.value);
        })
    }

    public get value(): number {
        return parseFloat(this._input.value.replace(",", "."));
    }

    public set value(value: number) {
        value = e5.Calc.clamp(value, this._minValue, this._maxValue);
        this._input.value = value.toFixed(2);
        var ratio = (value - this._minValue) / (this._maxValue - this._minValue);
        var x = ratio * (this._track.offsetWidth - (this._thumb.offsetWidth));
        this._thumb.style.transform = `translateX(${x}px)`;
    }

    public get disabled(): boolean {
        return this.element.classList.contains("disabled");
    }

    public set disabled(disabled: boolean) {
        this.element.classList.toggle("disabled", disabled);
    }
}